import { render, staticRenderFns } from "./GeoJsonMap.vue?vue&type=template&id=39b827c0&scoped=true&"
import script from "./GeoJsonMap.vue?vue&type=script&lang=ts&"
export * from "./GeoJsonMap.vue?vue&type=script&lang=ts&"
import style0 from "./GeoJsonMap.vue?vue&type=style&index=0&id=39b827c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b827c0",
  null
  
)

export default component.exports